import type { SellerRegistrationStatus } from '@m8-app/contracts';
import { cn } from './cn.js';

interface Config {
  label: string;
  dot:   string;
  bg:    string;
  text:  string;
  ring:  string;
}

const CONFIG: Record<SellerRegistrationStatus, Config> = {
  pending:    { label: 'Registered', dot: 'bg-amber-400 animate-pulse', bg: 'bg-amber-50',  text: 'text-amber-700',  ring: 'ring-amber-200/60'  },
  activated:  { label: 'Activated',  dot: 'bg-emerald-500',             bg: 'bg-emerald-50', text: 'text-emerald-700', ring: 'ring-emerald-200/60' },
  claimed:    { label: 'Claimed',    dot: 'bg-blue-500',                bg: 'bg-blue-50',   text: 'text-blue-700',   ring: 'ring-blue-200/60'   },
  superseded: { label: 'Superseded', dot: 'bg-slate-400',               bg: 'bg-slate-100', text: 'text-slate-600',  ring: 'ring-slate-200/60'  },
};

export function StatusBadge({ status }: { status: SellerRegistrationStatus }) {
  const c = CONFIG[status];
  return (
    <span className={cn(
      'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-medium ring-1',
      c.bg, c.text, c.ring,
    )}>
      <span className={cn('w-1.5 h-1.5 rounded-full shrink-0', c.dot)} />
      {c.label}
    </span>
  );
}
